const getFreeShippingAndAvailability = /* GraphQL */ `
  query GetFreeShippingAndAvailability($request: ProductPageRequestInput) {
    freeShippingAndAvailability(request: $request) {
      warehouseAvailability {
        warehouseId
        availability
        availabilityString
      }
    }
  }
`

export default getFreeShippingAndAvailability
